import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Baidu = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.412 6.937c-.36-.283-.924-.4-1.463-.365-.416.026-.761.034-1.005.182-1.116.677-1.217 4.353.182 4.934 2.974 1.236 4.057-3.35 2.286-4.751zm-4.479 3.838c-.963-1.119-1.64-2.681-3.563-2.376-1.706.272-1.924 1.67-2.833 2.65-1.08 1.164-3.105 2.018-3.564 3.838-.335 1.329.116 2.892.913 3.473 1.566 1.137 4.474-.125 6.58.09 1.26.13 2.225.573 3.198.55 2.262-.054 4.09-1.67 3.107-4.295-.48-1.286-2.6-2.494-3.838-3.93zm-.274-3.93c1.134.033 2.302-1.264 2.376-2.467.098-1.57-.93-3.143-2.467-2.741-.914.239-1.664 1.41-1.736 2.56-.083 1.331.617 2.615 1.827 2.649zM8.273 6.48C9.45 6.321 9.94 4.908 9.736 3.282 9.566 1.943 8.84.645 7.268 1.089 5.103 1.7 5.448 6.862 8.273 6.48zM4.16 10.592c2.583-.385 1.98-5.938-.822-5.3-2.41.55-2.087 5.735.822 5.3z"
  }));
});
Baidu.displayName = 'Baidu';
export var BaiduDimensions = {
  height: 20,
  width: 20
};